import { isEmpty, toNumber, toString } from 'lodash-es'

import { StringText } from '@/Atomic/Atoms/StringText'
import { CellRendererParams } from '@/Components/EntityTable/types'
import { SchemaAttributes } from '@/Data/types'
import { EnumValue, SchemaAttribute } from '@/Data/typesV2'
import { ensureString } from '@/utils/ensureString'
import { getLocalizedSchemaAttributes } from '@/utils/schemaLocalization'

const numberFormatter = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const AmountWithCurrencyCell = ({
  dataItem,
  schema,
}: CellRendererParams) => {
  const amount = dataItem.get('totalPrice')
  const currencyValue = ensureString(dataItem.get('totalPriceCurrency'))

  const currencyAttribute = getLocalizedSchemaAttributes(
    schema.get('attributes') as SchemaAttributes,
  )?.totalPriceCurrency as SchemaAttribute | undefined

  const currency = getCurrencyDisplayValue(
    currencyAttribute?.enumValues,
    currencyValue,
  )
  const value = isEmpty(toString(amount))
    ? '-'
    : [numberFormatter.format(toNumber(amount)), currency]
        .filter(Boolean)
        .join(' ')

  return (
    <div style={{ width: '100%', textAlign: 'right' }}>
      <StringText value={value} />
    </div>
  )
}

const getCurrencyDisplayValue = (
  enumValues: EnumValue[] | undefined,
  value: string,
) => {
  if (!value) {
    return ''
  }

  const enumValue = enumValues?.find((entry) => entry.value === value)

  return ensureString(enumValue?.data?.symbol || enumValue?.title || value)
}
